import { URLSearchParams } from 'url';
import { StateCreator } from 'zustand';

import { config } from '../../config';
import { ParameterState } from './types/ParameterState';

export const keysToPersist = [
  'amount',
  'applicationType',
  'applicationUpdateMessage',
  'apr',
  'authType',
  'autopayNumber',
  'coApplicantCollectAgreeToTerms',
  'collectAgreeToTerms',
  'firstName',
  'hasDuplicateApplication',
  'leadChannelCode',
  'migrateUser',
  'monthlyPaymentAmount',
  'payment',
  'phoneNumber',
  'term',
  'vehicle_vin',
  'vehicleId',
];

export const parameterStore: StateCreator<ParameterState> = (set, get) => ({
  amount: null,
  applicationType: null,
  applicationUpdateMessage: null,
  apr: null,
  authType: null,
  autopayNumber: null,
  coApplicantCollectAgreeToTerms: null,
  collectAgreeToTerms: null,
  firstName: null,
  hasDuplicateApplication: null,
  intent: null,
  leadChannelCode: null,
  mailCode: null,
  migrateUser: null,
  monthlyPaymentAmount: null,
  payment: null,
  phoneNumber: null,
  term: null,
  vehicle_vin: null,
  vehicleId: null,

  clearHasDuplicateApplication(): void {
    set({ hasDuplicateApplication: null });
  },
  setFromURLSearchParams(searchParams?: URLSearchParams): void {
    if (!searchParams) {
      return;
    }

    Object.keys(get())
      .filter((stateKey: string): boolean => searchParams.has(stateKey))
      .forEach((stateKey: string): void => {
        set({ [stateKey]: searchParams.get(stateKey) });
      });
  },
  toggleLeadChannelCode(enableOriginChannelAttribution?: boolean): void {
    // explicitly check for false to allow undefined to mean "do nothing"
    if (enableOriginChannelAttribution === false) {
      set({ leadChannelCode: config.defaultLeadChannelCodeForCancelledApps });
    }
  },
});
